/**
 * Check if a value is a number
 * @param n value to check
 * @returns n is a number
 */
const isNumber = (n: unknown) =>
    // eslint-disable-next-line no-restricted-globals
    !isNaN(parseFloat(n as string)) && !isNaN((n as number) - 0);
export default isNumber;
